import React, { useEffect } from 'react';

import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import { useCashClosure } from '../../hooks/cash/useCashClosure';

import CashClosureSessionCard from '../../components/CashClosingZ/CashClosureSessionCard';
import CashClosureSummary from '../../components/CashClosingZ/CashClosureSummary';
import CashCountDenominationSheet from '../../components/CashCount/CashCountDenominationSheet';
import CashClosureObservations from '../../components/CashClosingZ/CashClosureObservations';

const CashClosurePage: React.FC = () => {
  const {
    closureStarted,
    closureNumber,
    expectedCash,
    countedCash,
    difference,
    totalSales,
    observations,
    updateDenominations,
    updateObservation,
    getActive,
  } = useCashClosure();

  useEffect(() => {
    getActive();
  }, []);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <div className="space-y-6">
        {/* 🔝 CARD SUPERIOR (SIEMPRE) */}
        <CashClosureSessionCard />

        {/* 🔥 SI NO HA INICIADO → NO MOSTRAR NADA MÁS */}
        {!closureStarted ? null : (
          <div className="grid grid-cols-1 gap-6 xl:grid-cols-3">
            {/* IZQUIERDA */}
            <div className="xl:col-span-2">
              <CashCountDenominationSheet
                disabled={!closureStarted}
                auditStarted={closureStarted}
                onChange={updateDenominations}
              />
            </div>

            {/* DERECHA */}
            <div className="xl:col-span-1">
              <div className="sticky top-24 space-y-6">
                <CashClosureSummary
                  closureNumber={closureNumber}
                  totalSales={totalSales}
                  expectedCash={expectedCash}
                  countedCash={countedCash}
                  difference={difference}
                />

                <CashClosureObservations
                  value={observations}
                  onChange={updateObservation}
                  disabled={!closureStarted}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </DefaultLayout>
  );
};

export default CashClosurePage;
